import api from './axiosInstance';

export const getDailyStatePriorityLevels = async () => {
  const { data } = await api.get('/DailyStatePriorityLevel');
  return data;
};

export const getKeywordsByBusinessArea = async (businessAreaId) => {
  const { data } = await api.get(
    `/DailyStatePriority/business-area/${businessAreaId}`
  );
  return data;
};

export const createKeyword = async ({
  businessAreaId,
  dailyStateProcess,
  priorityLevelId,
  userId,
}) => {
  const { data } = await api.post('/DailyStatePriority', null, {
    params: {
      businessAreaId,
      dailyStateProcess,
      priorityLevelId,
      userId,
    },
  });

  return data;
};

export const updateKeyword = async (
  id,
  { dailyStateProcess, priorityLevelId, userId }
) => {
  const { data } = await api.put(`/DailyStatePriority/${id}`, null, {
    params: {
      dailyStateProcess,
      priorityLevelId,
      userId,
    },
  });

  return data;
};

export const deleteKeyword = async (id, userId) => {
  await api.delete(`/DailyStatePriority/${id}`, {
    params: {
      userId,
    },
  });
};
